/**
 * Track Event Plugin (Client-only)
 *
 * Provides $trackEvent — a high-level event tracking service with:
 * - Automatic enrichment (page_path, page_title, referrer, UTMs)
 * - Automatic conversion routing (trial_signup_intent → SignUp, generate_lead → Lead)
 *
 * Must load AFTER trackingAnalytics.client.ts and adTracking.client.ts.
 */

import { Context, Inject } from '@nuxt/types/app'
import { TrackEventService } from '~/services/tracking/TrackEventService'

declare module 'vue/types/vue' {
  interface Vue {
    $trackEvent: TrackEventService
  }
}

declare module 'vuex/types/index' {
  // skipcq: JS-0387, JS-0356
  interface Store<S> {
    $trackEvent: TrackEventService
  }
}

declare module '@nuxt/types' {
  interface Context {
    $trackEvent: TrackEventService
  }
}

export default (context: Context, inject: Inject): void => {
  const trackEventService = new TrackEventService(
    context.$trackingAnalytics,
    context.$adTracking || null
  )

  inject('trackEvent', trackEventService)
}
